import AsyncStorage from "@react-native-async-storage/async-storage";

import {
    isAppThemePreference,
    type AppThemePreference,
} from "./themePreference";

const THEME_STORAGE_KEY = "app.theme";

export async function getStoredTheme(): Promise<AppThemePreference | null> {
    const value = await AsyncStorage.getItem(THEME_STORAGE_KEY);
    if (!value || !isAppThemePreference(value)) {
        return null;
    }
    return value;
}

export async function setStoredTheme(theme: AppThemePreference): Promise<void> {
    await AsyncStorage.setItem(THEME_STORAGE_KEY, theme);
}
